<div class="row">
  <div class="col-md-6">
    <div class="card">
      <div class="card-body">
        <h4 class="card-title">Auth User Applications {{Title}}</h4>
        <div class="form-group">
          <label>User Account *</label>
          <div class="input-group">
            <input type="text" class="form-control" #UserAccount (selectItem)="selectedItem($event)"
              [ngbTypeahead]="search" [inputFormatter]="formatter" [resultTemplate]="rt" [(ngModel)]="Doc.SelectedAuthUser"
              placeholder="">
            <ng-template #rt let-r="result" let-t="term">
              <i class="fas fa-user mr-2"></i>
              <ngb-highlight [result]="r.UserAccount" [term]="t"></ngb-highlight>
            </ng-template>
          </div>
        </div>
        <div class="form-group">
          <label for="ApplicationID">ApplicationID *</label>
          <div class="input-group">
            <ng-select [searchable]="false" placeholder="Select ApplicationID" [items]="Doc.ddlAuthApplication" bindValue="value"
              bindLabel="text" [clearable]="false" [(ngModel)]="Doc.ApplicationID"
              style="width:100%">
            </ng-select>
          </div>
        </div>
        <div class="form-group">
          <label for="Enabled">IsEnabled</label>
          <ng-select [searchable]="false" [items]="Doc.ddlIsEnabled" id="IsEnabled" bindValue="value" bindLabel="text"
            [clearable]="false" [(ngModel)]="Doc.SelectEnabled">
          </ng-select>
        </div>
        <p>(*) Mandatory</p>
      </div>
      <div class="border-top">
        <div class="card-body">
          <button (click)="Cancel()" class="btn btn-outline-secondary" role="button">Cancel</button>
          <button (click)="Submit()" class="btn btn-success ml-1" role="button" [disabled]="isValid()">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>